import React, { useContext } from "react"
import propTypes from "prop-types"
import { OfflineContext } from "App"

function currencyFormatter(value) {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  return formatter.format(Number(value || 0))
}

function getProductDescription(product, isOffline) {
  if (isOffline) {
    return product.name || product.description || ""
  }

  return (
    product.description ||
    product.product?.description ||
    product.product?.product?.name ||
    product.product?.name ||
    ""
  )
}

function getSuggestedPrice(product) {
  const explicitSuggested =
    product.suggested ?? product.suggested_price ?? product.suggestedPrice ?? product.price_suggested
  const explicitSuggestedNumber = Number(explicitSuggested)

  if (!Number.isNaN(explicitSuggestedNumber)) {
    return explicitSuggestedNumber
  }

  const prices = product.product?.prices || product.product?.product?.prices || product.prices || []
  const suggestedPrice = prices.find((price) => {
    const normalizedValues = [price?.identifier, price?.name, price?.code]
      .filter(Boolean)
      .map((value) =>
        String(value)
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .trim()
          .toUpperCase()
      )

    return normalizedValues.includes("SUGERIDO") || normalizedValues.includes("P10")
  })

  const suggestedAmount = Number(suggestedPrice?.amount)

  return Number.isNaN(suggestedAmount) ? null : suggestedAmount
}

function formatSuggested(value) {
  if (value === null || value === undefined) {
    return "-"
  }

  return currencyFormatter(value)
}

const styles = {
  table: {
    fontSize: "12px",
    width: "100%",
    borderCollapse: "collapse",
  },
  cell: {
    color: "black",
    fontSize: "11px",
    lineHeight: "14px",
    padding: "0 2px",
  },
  rowHeader: {
    borderBottom: "1px solid black",
  },
}

const TableProduct = ({ products }) => {
  // eslint-disable-next-line
  const { isOffline, setIsOffline } = useContext(OfflineContext)
  const safeProducts = Array.isArray(products) ? products : []

  return (
    <>
      <p style={{ borderBottom: "1px solid black", margin: "5px 0" }} />
      <table style={styles.table}>
        <thead style={styles.rowHeader}>
          <tr>
            <th style={{ ...styles.cell, textAlign: "center", paddingLeft: "0px" }}>C.</th>
            <th style={{ ...styles.cell, textAlign: "left", width: "40%" }}>Descripcion</th>
            <th style={{ ...styles.cell, textAlign: "right" }}>Precio</th>
            <th style={{ ...styles.cell, textAlign: "right" }}>Importe</th>
            <th style={{ ...styles.cell, textAlign: "right", paddingRight: "0px" }}>Sugerido</th>
          </tr>
        </thead>
        <tbody>
          {safeProducts.map((product, index) => {
            const suggested = getSuggestedPrice(product)
            const productKey = isOffline ? product.identifier || index : product.product?.key || product.id || index

            return (
              <tr key={productKey}>
                <td style={{ ...styles.cell, textAlign: "center", paddingLeft: "0px" }}>
                  {product.quantity}
                </td>
                <td style={{ ...styles.cell, textAlign: "left" }}>
                  {String(getProductDescription(product, isOffline)).substring(0, 16)}
                </td>
                <td style={{ ...styles.cell, textAlign: "right" }}>{currencyFormatter(product.price)}</td>
                <td style={{ ...styles.cell, textAlign: "right" }}>
                  {currencyFormatter(product.total ?? product.amount)}
                </td>
                <td style={{ ...styles.cell, textAlign: "right", paddingRight: "0px" }}>
                  {formatSuggested(suggested)}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </>
  )
}

TableProduct.propTypes = {
  products: propTypes.array,
}

export default TableProduct
